import { validate, ValidatorOptions } from "class-validator";

export interface ELValidationError {
	property: string;
	error: string;
}

export async function elValidate(object: Object, validatorOptions?: ValidatorOptions): Promise<ELValidationError[]> {
	const errors = await validate(object, validatorOptions);
	if (errors && errors.length) {
		return errors.map(err => ({ property: err.property, error: Object.values(err.constraints)[0] }));
	}
	return [];
}
